import { ColumnState } from "ag-grid-community";
import { create } from "zustand";
import {
	defaultSAL6030_R01Filter,
	SAL6030_R01DetailDto,
	SAL6030_R01Filter,
	SAL6030_R01GroupDto,
	SAL6030_R01HeaderDto,
} from "./Dto_SAL6030_R01";

export interface Store_SAL6030_R01 {
	// 검색 조건
	SAL6030_R01Filter: SAL6030_R01Filter;
	SAL6030_R01PastFilter: SAL6030_R01Filter;
	setSAL6030_R01Filter: (f: Partial<SAL6030_R01Filter>) => void;
	setSAL6030_R01PastFilter: (f: SAL6030_R01Filter) => void;

	// 상단 좌측 - 제품 목록
	SAL6030_R01List: SAL6030_R01HeaderDto[];
	setSAL6030_R01List: (list: SAL6030_R01HeaderDto[]) => void;
	selectedSAL6030_R01List: SAL6030_R01HeaderDto | undefined;
	setSelectedSAL6030_R01List: (row: SAL6030_R01HeaderDto | undefined) => void;

	// 상단 우측 - 품목그룹별 원가
	SAL6030_R01groupList: SAL6030_R01GroupDto[];
	setSAL6030_R01GroupList: (list: SAL6030_R01GroupDto[]) => void;
	selectedSAL6030_R01Group: SAL6030_R01GroupDto | undefined;
	setSelectedSAL6030_R01Group: (row: SAL6030_R01GroupDto | undefined) => void;

	// 하단 - 소요자재 원가 상세
	SAL6030_R01detailList: SAL6030_R01DetailDto[];
	setSAL6030_R01DetailList: (list: SAL6030_R01DetailDto[]) => void;
	selectedSAL6030_R01Detail: SAL6030_R01DetailDto | undefined;
	setSelectedSAL6030_R01Detail: (row: SAL6030_R01DetailDto | undefined) => void;

	// 컬럼 상태
	columnState: ColumnState[] | null;
	setColumnState: (s: ColumnState[] | null) => void;
	groupColumnState: ColumnState[] | null;
	setGroupColumnState: (s: ColumnState[] | null) => void;
	detailColumnState: ColumnState[] | null;
	setDetailColumnState: (s: ColumnState[] | null) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;
	groupScrollTop: number | null;
	setGroupScrollTop: (top: number | null) => void;
	detailScrollTop: number | null;
	setDetailScrollTop: (top: number | null) => void;

	allCount: number;
	setAllCount: (n: number) => void;

	initData: () => void;
}

export const useSAL6030_R01Store = create<Store_SAL6030_R01>((set) => ({
	SAL6030_R01Filter: defaultSAL6030_R01Filter,
	SAL6030_R01PastFilter: defaultSAL6030_R01Filter,
	setSAL6030_R01Filter: (update) =>
		set((state) => ({
			SAL6030_R01Filter: { ...state.SAL6030_R01Filter, ...update },
		})),
	setSAL6030_R01PastFilter: (f) => set({ SAL6030_R01PastFilter: f }),

	SAL6030_R01List: [],
	setSAL6030_R01List: (list) =>
		set({
			SAL6030_R01List: list.map((item, idx) => ({
				...item,
				valueIndex: item.valueIndex && item.valueIndex > 0 ? item.valueIndex : idx + 1,
			})),
		}),
	selectedSAL6030_R01List: undefined,
	setSelectedSAL6030_R01List: (row) =>
		set({
			selectedSAL6030_R01List: row,
			groupScrollTop: null,
			detailScrollTop: null,
		}),

	SAL6030_R01groupList: [],
	setSAL6030_R01GroupList: (list) =>
		set({
			SAL6030_R01groupList: list.map((item, idx) => ({
				...item,
				valueIndex: item.valueIndex && item.valueIndex > 0 ? item.valueIndex : idx + 1,
			})),
		}),
	selectedSAL6030_R01Group: undefined,
	setSelectedSAL6030_R01Group: (row) => set({ selectedSAL6030_R01Group: row }),

	SAL6030_R01detailList: [],
	setSAL6030_R01DetailList: (list) =>
		set({
			SAL6030_R01detailList: list.map((item, idx) => ({
				...item,
				valueIndex: item.valueIndex && item.valueIndex > 0 ? item.valueIndex : idx + 1,
			})),
		}),
	selectedSAL6030_R01Detail: undefined,
	setSelectedSAL6030_R01Detail: (row) => set({ selectedSAL6030_R01Detail: row }),

	columnState: null,
	setColumnState: (s) => set({ columnState: s }),
	groupColumnState: null,
	setGroupColumnState: (s) => set({ groupColumnState: s }),
	detailColumnState: null,
	setDetailColumnState: (s) => set({ detailColumnState: s }),

	scrollTop: null,
	setScrollTop: (top) => set({ scrollTop: top }),
	groupScrollTop: null,
	setGroupScrollTop: (top) => set({ groupScrollTop: top }),
	detailScrollTop: null,
	setDetailScrollTop: (top) => set({ detailScrollTop: top }),

	allCount: 0,
	setAllCount: (n) => set({ allCount: n }),

	initData: () =>
		set({
			SAL6030_R01Filter: defaultSAL6030_R01Filter,
			SAL6030_R01PastFilter: defaultSAL6030_R01Filter,
			SAL6030_R01List: [],
			selectedSAL6030_R01List: undefined,
			SAL6030_R01groupList: [],
			selectedSAL6030_R01Group: undefined,
			SAL6030_R01detailList: [],
			selectedSAL6030_R01Detail: undefined,
			columnState: null,
			groupColumnState: null,
			detailColumnState: null,
			scrollTop: null,
			groupScrollTop: null,
			detailScrollTop: null,
			allCount: 0,
		}),
}));
